import React from 'react'
import CompletedCoursesList from './CompletedCoursesList'

const CompletedCourses = () => {
    return (
        <div className='w-full mb-6 md:mb-[42px]'>
            <div className='w-full font-bold text-[#151515] text-lg sm:text-xl leading-[28px] sm:leading-[30px]'>
                <div className='mb-3 sm:mb-4'>Completed Courses</div>
            </div>
            <div>
                <CompletedCoursesList />
            </div>
        </div>
    )
}

export default CompletedCourses